import { Link } from 'react-router-dom';

const stats = [
  { icon: 'ri-article-line', value: '2,700+', label: '资讯文章' },
  { icon: 'ri-play-circle-line', value: '500+', label: '趣味视频' },
  { icon: 'ri-tv-2-line', value: '40+', label: '热播综艺' },
  { icon: 'ri-user-smile-line', value: '120万', label: '月度读者' },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-200/60">
      <div className="max-w-[1280px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-information-line" />
            关于搞鸡
          </span>
          <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
            搞鸡娱乐资讯网
          </h1>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-4">
            搞鸡专注于综艺娱乐新闻和趣味内容，为你提供及时、丰富、多元的娱乐资讯与视频推荐。
            从最新综艺节目介绍、娱乐圈热点话题，到搞笑视频与精彩评论，我们希望成为你每天轻松一刻的起点。
          </p>
          <div className="flex flex-wrap items-center gap-3 mt-7">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解更多
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/category/news"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 hover:border-primary-400 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              浏览娱乐新闻
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-4">
          {stats.map((s) => (
            <div key={s.label} className="bg-background-50 rounded-lg border border-background-200 p-5 md:p-6">
              <span className="w-11 h-11 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center text-2xl mb-4">
                <i className={s.icon} />
              </span>
              <p className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{s.value}</p>
              <p className="text-xs md:text-sm text-foreground-500 mt-1">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}